export default __webpack_public_path__ + "static/O0246-fa2fa0039a17b90d1b57d1d8271a00be.png";